export default {
  profiles: [],
  totalElements: 0,
  totalPages: 0,
  currentPage: 0,
  pageSize: 100,
  loading: false,
  error: null,
  selectedIds: [],
  search: '',
};
